import {Component, OnInit} from '@angular/core';
import {StoreInvoice} from '../../../core/shared/model/StoreInvoice';
import * as moment from 'moment';
import {UserService} from '../../../core/services/user.service';
import {StatementsService} from '../statements.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {PageChangeEvent, RowArgs, SelectAllCheckboxState,CellClickEvent, DataBindingDirective, ExcelExportEvent, GridComponent } from "@progress/kendo-angular-grid";
import {SortDescriptor} from '@progress/kendo-data-query';
import {DialogType, FSInvoiceDialogService} from '../../../core/services/fsinvoice.dialog.service';
import {ExcelService} from '../../../core/services/excel.service';
import {ReportParams} from '../../../core/shared/model/ReportParams';
import {InvoicesService} from '../../../core/services/invoices.service';
import {LoggingService} from 'mclane-apptemplate-lib';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {process} from '@progress/kendo-data-query';
import {downloadIcon} from "@progress/kendo-svg-icons";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-statements-invoices',
  templateUrl: './statements-invoices.component.html',
  styleUrls: ['./statements-invoices.component.scss'],
  providers: [ExcelService]
})
export class StatementsInvoicesComponent implements OnInit {
  data: any;
  invoices: Array<StoreInvoice>;
  selectedInvoices: Array<StoreInvoice> = new Array<StoreInvoice>();
  fromDate: string;
  endDate: string;
  selectedStores: Array<string> = new Array<string>();
  selectedRequestType: string;
  selectedInvType: string;
  selectedStartDate: Date;
  selectedEndDate: Date = moment().toDate();
  selectedParents: Array<string> = new Array<string>();
  userName: string;
  selectedKeys: string[];
  downloaded: boolean = false;
  download: string;
  fromRange: string;
  toRange: string;
  pageSize: number = 30;
  skip = 0;
  info = true;
  buttonCount = 5;
  type: 'numeric';
  pageSizes: number[] = [20, 40, 60];
  previousNext = true;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  loading: any;
  selectedInvoicesMap: Map<string, StoreInvoice> = new Map<string, StoreInvoice>();
  reportParams: Array<ReportParams> = new Array<ReportParams>();
  response: any;
  missing: string;
  pdf: string;
  returnUrl: string;
  masterSelect: boolean = false;

  sort: SortDescriptor[] = [{
    field: 'invoiceNumber',
    dir: 'asc'
  }];
  storeInvList: Array<StoreInvoice>

  constructor(public userService: UserService, public statementsService: StatementsService, private _route: ActivatedRoute, private _router: Router,
              public fsInvoiceDialog: FSInvoiceDialogService, public excelService: ExcelService, public invoiceService: InvoicesService, public console: LoggingService,
              public loadingIndicator: LoadingIndicatorHelper
  ) {
    this.selectedKeys = [];
  }

  get noSelection(): boolean {
    return this.selectedKeys.length === 0;
  }

  ngOnInit() {
    this.loadingIndicator.show();
    this.masterSelect = this.statementsService.getMasterInvoiceSelect();

    this.selectedStartDate = moment(this.userService.getSelectedStartDate()).toDate();
    this.selectedEndDate = moment(this.userService.getSelectedEndDate()).toDate();
    this.selectedInvType = this.userService.getSelectedInvType();
    this.selectedRequestType = this.userService.getSelectedRequestType();
    this.userName = this.userService.getUserName();
    this.fromDate = moment(this.selectedStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    this.selectedParents = this.userService.getSelectedInvoiceParents();
    this.selectedStores = this.userService.getSelectedStatementStores();
    this.selectedKeys = this.userService.getSelectedStatementInvoices();
    this.fromRange = this.userService.getFromRange();
    this.toRange = this.userService.getToRange();
    this.downloaded = this.userService.getDownloaded();
    if (this.downloaded) {
      this.download = 'Y';
    } else {
      this.download = 'N';
    }

    this.statementsService.getInvoiceSummary(this.selectedStores, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate).subscribe(invoices => {
      this.invoices = invoices;
      this.loadingIndicator.hide();
    });
    this.exportAllData = this.exportAllData.bind(this);
  }

  backClicked() {
    this.userService.setSelectedStatementInvoices(this.selectedKeys);
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };
    this._router.navigate(['/statementstores'], navigationExtras);
  };

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  tableHeaderCheckBoxChanged(checked: boolean) {
    if (checked) {
    }
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.invoiceNumber);

  allRowsSelected(selectionObj: any) {
    if (selectionObj == 'checked') {
      this.tableHeaderCheckBoxChanged(true);
      this.selectAllState = selectionObj;
    } else if (selectionObj == 'unchecked') {
      this.tableHeaderCheckBoxChanged(false);
      this.selectAllState = selectionObj;
    } else {

      selectionObj.deselectedRows.forEach(row => {
        var index = this.selectedKeys.indexOf(row.dataItem.invoiceNumber);
        this.selectedKeys.splice(index, 1);
        this.rowCheckBoxChanged(false, row.dataItem);
      });
      selectionObj.selectedRows.forEach(row => {
        if (!this.selectedKeys.includes(row.dataItem.invoiceNumber)) {
          this.selectedKeys.push(row.dataItem.invoiceNumber);
          this.rowCheckBoxChanged(true, row.dataItem);
        }
      });
    }
  }

  masterClicked() {
    if (this.masterSelect === false) {
      this.masterSelect = true;
      this.invoices.forEach(item => {
        this.selectedKeys.push(item.invoiceNumber);
        this.selectedInvoicesMap.set(item.invoiceNumber, item);
      });
    } else {
      this.masterSelect = false;
      this.selectedKeys.length = 0;
      this.selectedInvoicesMap.clear();
    }
    this.statementsService.setMasterInvoiceSelect(this.masterSelect);
  }

  rowCheckBoxChanged(checked: boolean, storeInvoice: StoreInvoice) {
    if (checked) {
      this.selectedInvoicesMap.set(storeInvoice.invoiceNumber, storeInvoice);
    } else {
      this.selectedInvoicesMap.delete(storeInvoice.invoiceNumber);
    }
  }

  selectionKey(context: RowArgs): string {
    return (context.dataItem.invoiceNumber);
  }

  viewStatement(): void {
    if (this.selectedKeys.length == 0)  {
      this.loadingIndicator.hide();
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else if(this.selectedKeys.length > 1350) {
      this.fsInvoiceDialog.open({
        type: DialogType.ERROR,
        title: 'View',
        content: this.selectedKeys.length + ' statements are selected. Maximum 1350 statements can be viewed at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      })
    } else {
      this.loadingIndicator.show();
      this.userService.setSelectedInvoicesMap(this.selectedInvoicesMap);
      this.selectedStores = this.userService.getSelectedInvoiceStores();

      this.statementsService.getStatementReport(this.selectedStores, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate, 'FSC0001A').subscribe(params => {
        this.reportParams = params;

        var mapForm = document.createElement('form');
        mapForm.target = 'Map';
        mapForm.method = 'POST'; // or "post" if appropriate
        this.reportParams.map(param => {
          if (param.entity == 'action') {
            mapForm.action = param.value;
          } else if (param.entity == 'form name') {
            mapForm.name = param.value;
          } else if (param.entity == 'method') {
            mapForm.method = param.value;
          }

          if (param.type != 'CFM') {
            var mapInput = document.createElement('input');
            mapInput.type = 'hidden';
            mapInput.name = param.entity;
            mapInput.value = param.value;
            mapForm.appendChild(mapInput);

          }
        });
        document.body.appendChild(mapForm);
        window.open('', 'Map', 'status=0,title=0,height=600,width=800,scrollbars=1');
        mapForm.submit();
      });
      this.selectedKeys = [];
      this.selectAllState = 'unchecked';
      this.loadingIndicator.hide();
    }
  }

  viewInvoice(): void {
    if (this.selectedKeys.length == 0)  {
      this.loadingIndicator.hide();
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else if (this.selectedKeys.length > 1350) {
      this.fsInvoiceDialog.open({
        type: DialogType.ERROR,
        title: 'View',
        content: this.selectedKeys.length + ' invoices are selected. Maximum 1350 invoices can be viewed at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      });
    } else {
      this.loadingIndicator.show();
      this.userService.setSelectedInvoicesMap(this.selectedInvoicesMap);
      this.invoiceService.getInvoices(this.selectedKeys).subscribe(res => {
        this.response = res;

        this.response = this.response.trim();
        let s = this.response.charAt(0);

        if (s >= '0' && s <= '9') {
          this.missing = this.response;
          this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Invoices ' + this.missing + ' are missing from pdf.');

        } else {
          let someString = this.response.toString();
          let index = someString.indexOf(' ');

          if (index == -1) {
            index = someString.length;
            this.pdf = someString.substr(0, index);

          } else {
            this.pdf = someString.substr(0, index);
            this.missing = someString.substr(index + 1);

            this.missing = this.missing.slice(0, -1);

            if (typeof this.pdf != 'undefined' && this.pdf) {
              this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Invoices ' + this.missing + ' are missing from pdf.');
            }
          }

          let binary_string = window.atob(this.pdf);
          let len = binary_string.length;
          let bytes = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }

          let file = new Blob([bytes.buffer], {type: 'application/pdf'});
          let fileURL = URL.createObjectURL(file);

          window.open(fileURL);
          this.loading = false;
        }
      });
      this.selectedKeys = [];
      this.selectAllState = 'unchecked';
      this.masterSelect = false;
      this.loadingIndicator.hide();
    }
  }

  getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  public exportAllData(): ExcelExportData {
    const result: ExcelExportData =  {
      data: process(this.storeInvList, {}).data
    };
    return result;
  }
  
  exportAsXLSX(bulkGrid: GridComponent) {
    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this.userService.setSelectedInvoicesMap(this.selectedInvoicesMap);
      this.selectedInvoices = new Array<StoreInvoice>();
      this.selectedInvoicesMap.forEach((storeInvoice, iNum) => {
        this.selectedInvoices.push(storeInvoice);
      });
      let tempDiscAmt = 0;
      this.storeInvList = this.selectedInvoices.map(item => {
        if (item.origBalance < 0) {
          tempDiscAmt = +Math.abs(item.discountAmount);
        } else {
          tempDiscAmt = -Math.abs(item.discountAmount);
        }
        item.amount=item.dueBalance-item.discountAmount;
        item.discountAmount=tempDiscAmt;
        return item;
      });
      var furtherInfo: Array<string> = new Array<string>();
      furtherInfo.join('info');
      this.fsInvoiceDialog.showConfirmationDialogWithFurtherInfo('Download', 'You have selected ' + this.selectedInvoices.length + ' invoice(s) for downloading `Do you wish to continue?`', furtherInfo, () => {
        try {
          this.loading = true;
          setTimeout(() => {
            bulkGrid.saveAsExcel();
            this.loading = false;
          }, 100);
        } catch (ex) {
          this.loading = false;
        }
      }, () => {
      });
    }
  }

  protected readonly downloadIcon = downloadIcon;
}
